import { render } from "./TvmMyVehicles.vue?vue&type=template&id=20a5ea2c&scoped=true"
import script from "./TvmMyVehicles.vue?vue&type=script&lang=js"
export * from "./TvmMyVehicles.vue?vue&type=script&lang=js"

import "./TvmMyVehicles.vue?vue&type=style&index=0&id=20a5ea2c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a5ea2c"],['__file',"src/Components/ChatWidget/TvmMyVehicles/TvmMyVehicles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20a5ea2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20a5ea2c', __exports__)) {
    api.reload('20a5ea2c', __exports__)
  }
  
  module.hot.accept("./TvmMyVehicles.vue?vue&type=template&id=20a5ea2c&scoped=true", () => {
    api.rerender('20a5ea2c', render)
  })

}


export default __exports__